import { render, staticRenderFns } from "./orderCollectionAccount.vue?vue&type=template&id=aa269c40"
import script from "./orderCollectionAccount.vue?vue&type=script&lang=js"
export * from "./orderCollectionAccount.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports